import { createSelector } from 'reselect';

export const selectLoans = state => state.loans;

export const selectCurrentLoanRequest = createSelector(selectLoans, loans => {
  return loans.currentLoanRequest;
});
